const sumFields = (inputs: $TSMigrationFixMe, fields: string[]) => {
  return fields.reduce((acc, path) => {
    const valueAccess = (inputs as $TSMigrationFixMe)?.[path]
    const value = valueAccess ? Number(valueAccess) : 0
    return acc + value
  }, 0)
}

export const calculateCasilla33TotalBases = (inputs: $TSMigrationFixMe) => {
  const fields = [
    "casilla700",
    "casilla667",
    "casilla01",
    "casilla702",
    "casilla03",
    "casilla05",
    "casilla704",
    "casilla671",
    "casilla500",
    "casilla706",
    "casilla502",
    "casilla504",
    "casilla708",
    "casilla675",
    "casilla643",
    "casilla710",
    "casilla645",
    "casilla647",
    "casilla712",
    "casilla679",
    "casilla07",
    "casilla714",
    "casilla09",
    "casilla11",
    "casilla13",
    "casilla716",
    "casilla683",
    "casilla21",
    "casilla718",
    "casilla23",
    "casilla25",
    "casilla720",
    "casilla687",
    "casilla545",
    "casilla722",
    "casilla547",
    "casilla551",
    "casilla27",
    "casilla29",
    "casilla649",
    "casilla31",
  ]
  return sumFields(inputs, fields)
}

export const calculateCasilla34TotalCuotasDevengadas = (
  inputs: $TSMigrationFixMe
) => {
  const fields = [
    "casilla701",
    "casilla668",
    "casilla02",
    "casilla703",
    "casilla04",
    "casilla06",
    "casilla705",
    "casilla672",
    "casilla501",
    "casilla707",
    "casilla503",
    "casilla505",
    "casilla709",
    "casilla676",
    "casilla644",
    "casilla711",
    "casilla646",
    "casilla648",
    "casilla713",
    "casilla680",
    "casilla08",
    "casilla715",
    "casilla10",
    "casilla12",
    "casilla14",
    "casilla717",
    "casilla684",
    "casilla22",
    "casilla719",
    "casilla24",
    "casilla26",
    "casilla721",
    "casilla688",
    "casilla546",
    "casilla723",
    "casilla548",
    "casilla552",
    "casilla28",
    "casilla30",
    "casilla650",
    "casilla32",
  ]
  return sumFields(inputs, fields)
}

// TODO VERIFICAR CUANDO SE HAGA POST DECLARACION
export const calculateCasilla47TotalCuotasRecargoEquivalencia = (
  inputs: $TSMigrationFixMe
) => {
  const fields = [
    "casilla34",
    "casilla664",
    "casilla692",
    "casilla36",
    "casilla666",
    "casilla694",
    "casilla600",
    "casilla602",
    "casilla42",
    "casilla44",
    "casilla46",
  ]
  return sumFields(inputs, fields)
}

export const calculateCasilla48 = (inputs: $TSMigrationFixMe) => {
  const fields = [
    "casilla695",
    "casilla190",
    "casilla724",
    "casilla603",
    "casilla605",
  ]
  return sumFields(inputs, fields)
}
export const calculateCasilla49 = (inputs: $TSMigrationFixMe) => {
  const fields = [
    "casilla696",
    "casilla191",
    "casilla725",
    "casilla604",
    "casilla606",
  ]
  return sumFields(inputs, fields)
}

export const calculateCasilla512 = (inputs: $TSMigrationFixMe) => {
  const fields = [
    "casilla745",
    "casilla506",
    "casilla726",
    "casilla607",
    "casilla609",
  ]
  return sumFields(inputs, fields)
}

export const calculateCasilla513 = (inputs: $TSMigrationFixMe) => {
  const fields = [
    "casilla746",
    "casilla507",
    "casilla727",
    "casilla608",
    "casilla610",
  ]
  return sumFields(inputs, fields)
}
export const calculateCasilla50 = (inputs: $TSMigrationFixMe) => {
  const fields = [
    "casilla749",
    "casilla196",
    "casilla728",
    "casilla611",
    "casilla613",
  ]
  return sumFields(inputs, fields)
}

export const calculateCasilla51 = (inputs: $TSMigrationFixMe) => {
  const fields = [
    "casilla750",
    "casilla197",
    "casilla729",
    "casilla612",
    "casilla614",
  ]
  return sumFields(inputs, fields)
}

export const calculateCasilla520 = (inputs: $TSMigrationFixMe) => {
  const fields = [
    "casilla753",
    "casilla514",
    "casilla730",
    "casilla615",
    "casilla617",
  ]
  return sumFields(inputs, fields)
}

export const calculateCasilla521 = (inputs: $TSMigrationFixMe) => {
  const fields = [
    "casilla755",
    "casilla515",
    "casilla731",
    "casilla616",
    "casilla618",
  ]
  return sumFields(inputs, fields)
}

export const calculateCasilla52 = (inputs: $TSMigrationFixMe) => {
  const fields = [
    "casilla757",
    "casilla202",
    "casilla732",
    "casilla619",
    "casilla621",
  ]
  return sumFields(inputs, fields)
}

export const calculateCasilla53 = (inputs: $TSMigrationFixMe) => {
  const fields = [
    "casilla758",
    "casilla203",
    "casilla733",
    "casilla620",
    "casilla622",
  ]
  return sumFields(inputs, fields)
}

export const calculateCasilla54 = (inputs: $TSMigrationFixMe) => {
  const fields = [
    "casilla761",
    "casilla208",
    "casilla734",
    "casilla623",
    "casilla625",
  ]
  return sumFields(inputs, fields)
}

export const calculateCasilla55 = (inputs: $TSMigrationFixMe) => {
  const fields = [
    "casilla762",
    "casilla209",
    "casilla735",
    "casilla624",
    "casilla626",
  ]
  return sumFields(inputs, fields)
}

export const calculateCasilla56 = (inputs: $TSMigrationFixMe) => {
  const fields = [
    "casilla765",
    "casilla214",
    "casilla736",
    "casilla627",
    "casilla629",
  ]
  return sumFields(inputs, fields)
}

export const calculateCasilla57 = (inputs: $TSMigrationFixMe) => {
  const fields = [
    "casilla766",
    "casilla215",
    "casilla737",
    "casilla628",
    "casilla630",
  ]
  return sumFields(inputs, fields)
}

export const calculateCasilla58 = (inputs: $TSMigrationFixMe) => {
  const fields = [
    "casilla769",
    "casilla220",
    "casilla738",
    "casilla631",
    "casilla633",
  ]
  return sumFields(inputs, fields)
}

export const calculateCasilla59 = (inputs: $TSMigrationFixMe) => {
  const fields = [
    "casilla770",
    "casilla221",
    "casilla739",
    "casilla632",
    "casilla634",
  ]
  return sumFields(inputs, fields)
}

export const calculateCasilla597 = (inputs: $TSMigrationFixMe) => {
  const fields = [
    "casilla773",
    "casilla587",
    "casilla740",
    "casilla635",
    "casilla637",
  ]
  return sumFields(inputs, fields)
}

export const calculateCasilla598 = (inputs: $TSMigrationFixMe) => {
  const fields = [
    "casilla774",
    "casilla588",
    "casilla741",
    "casilla636",
    "casilla638",
  ]
  return sumFields(inputs, fields)
}

export const calculateCasilla64 = (inputs: $TSMigrationFixMe) => {
  const fields = [
    "casilla49",
    "casilla513",
    "casilla51",
    "casilla521",
    "casilla53",
    "casilla55",
    "casilla57",
    "casilla59",
    "casilla598",
    "casilla61",
    "casilla661",
    "casilla62",
    "casilla652",
    "casilla63",
    "casilla522",
  ]
  return sumFields(inputs, fields)
}

export const calculateCasilla155 = (inputs: $TSMigrationFixMe) => {
  const fields = [
    "casilla140",
    "casilla142",
    "casilla144",
    "casilla146",
    "casilla148",
    "casilla150",
    "casilla152",
    "casilla153",
    "casilla154",
  ]
  return sumFields(inputs, fields)
}

export const calculateCasilla172 = (inputs: $TSMigrationFixMe) => {
  const fields = [
    "casilla157",
    "casilla159",
    "casilla161",
    "casilla163",
    "casilla165",
    "casilla167",
    "casilla169",
    "casilla170",
    "casilla171",
  ]
  return sumFields(inputs, fields)
}

export const calculateCasilla189 = (inputs: $TSMigrationFixMe) => {
  const fields = [
    "casilla174",
    "casilla176",
    "casilla178",
    "casilla180",
    "casilla182",
    "casilla184",
    "casilla186",
    "casilla187",
    "casilla188",
  ]
  return sumFields(inputs, fields)
}
